import './messages.scss';
export default function HelperMessage(){
    return(
        <div className='helper-message'>
            <p className='px18 white'>wadd</p>
        </div>
    );
}